/*
 * @Author: 刘枫
 * @Date: 2020-10-27 10:41:52
 * @Last Modified by: 李志远
 * @Last Modified time: 2022-07-Fr 11:53:24
 */

<template>
  <!-- 购物车结算页 -->
  <div class="checkout">
    <div class="cart-nav">
      <img
        src="//static.kxymall.com/images/lc.jpg"
        alt="购物车及购物车进程"
      >
    </div>
    <div>请确认以下信息，然后提交订单</div>
    <div class="content">
      <!--  2020.4.11 wanglu  -->
      <div class="same_module consignee_adr wrap">
        <div class="same_module_rel">
          <div class="mod_rel_head clearfix">
            <span class="mr_tit">收货信息</span>
            <a
              class="mr_ctrlbtn"
              @click.stop.prevent="cAddAddress"
            >新建地址</a>
          </div>
          <div class="consign_rel_cont">
            <ul
              id="consignee-list"
              class="clearfix"
              :class="[isActive?'changes':'chang']"
            >
              <li
                id=""
                v-for="(item, index) of addressList"
                class="consignee-item item-selected "
                :class="{cur:currentIndex===index}"
                :key="item.addressId"
                @click.stop.prevent="checkAddre(item.addressId,index,item.countyName, item)"
              >
                <div
                  class="total_info clearfix op-btns"
                  id="consignee_index_div_-2128470671"
                >
                  <i class="fl sprite_odr  adr_icon"></i>
                  <span class="fl tot_name">{{item.consigneeName}} {{item.province}}</span>
                  <em
                    class="init_adrs"
                    v-show="item.defaultAddress==1"
                  >默认</em>
                </div>
                <div class="detail_info">
                  <p>{{item.consigneeName}}<span class='ml5'>{{item.mobile}}</span></p>
                  <p>{{item.province}} {{item.city}} {{item.region}} {{item.countyName || ""}}</p>
                  <p>{{item.address}}</p>
                </div>
                <div class="sprite_odr is_choose"></div>
              </li>
              <input
                type="hidden"
                id="hidden_consignees_size"
                value="5"
              >

            </ul>
            <span
              class="cng_more"
              href="#none"
              @click="showMoreAddr()"
              v-show='isMoreAddr'
            ><span>更多地址</span><em :class="[isActive?'sprite_odrs':'sprite_odr']"></em></span>
          </div>
        </div>
      </div>
      <div
        class="same_module consignee_adr wrap"
        v-show="(couponLimit>0||usedSelfShoppingPv>0) && parseFloat(myCoupon)"
      >
        <div class="same_module_rel address">
          <div class="mod_rel_head clearfix">
            <span class="mr_tit">付款方式</span>
          </div>
          <div class="payment">
            <div v-show="!sureEdit">请先填写收货人信息。</div>
            <div
              v-show="sureEdit"
              class="way assets_rel_cont"
            >
              <li
                class="item assets_items"
                v-if="couponLimit> 0 && parseFloat(myCoupon)"
              >
                <div class="assets_itms_info clearfix">
                  <div class="aii_labe clearfix">
                    <b class="fl">现金券</b>
                  </div>
                  <div class="aii_tiptxt">当前使用现金券金额：<strong style="color:red;font-size:16px;">¥{{parseFloat(couponLimit)}}</strong>，
                    可用现金券余额：¥{{myCoupon}} </div>
                  <label class="aii_chkbox"><input
                      type="checkbox"
                      id="coupon"
                      v-model="couponUsed"
                      @click="clickCoupon"
                    > <em>使用</em> </label>
                  <span class="fr sp_totals"> - ¥ {{parseFloat(couponLimit)}}</span>
                </div>
              </li>
              <li
                class="item assets_items"
                v-if="usedSelfShoppingPv> 0 && parseFloat(mySignRebate)"
              >
                <div class="assets_itms_info clearfix">
                  <div class="aii_labe clearfix">
                    <b class="fl">自营购物积分</b>
                  </div>
                  <div class="aii_tiptxt">当前使用自营购物积分：<strong style="color:red;font-size:16px;">¥{{usedSelfShoppingPv}}</strong>， 可用自营购物积分余额：¥{{mySignRebate}}
                  </div>
                  <label class="aii_chkbox"><input
                      type="checkbox"
                      v-model="selfShoppingPvFlag"
                      @click="clickSelfShoppingPv"
                    > <em>使用</em> </label>
                  <span class="fr sp_totals"> - ¥ {{usedSelfShoppingPv}}</span>
                </div>
              </li>
            </div>
          </div>
        </div>
      </div>

      <!-- 结算商品列表 -->
      <div class="same_module list">
        <div class="mod_rel_head clearfix">
          <span class="mr_tit">商品清单</span>
          <a
            class="mr_ctrlbtn"
            v-show="buyType === 1"
            @click.stop.prevent="cReturnCart"
          >[返回购物车修改]</a>
        </div>
        <!--         <div class="title">商品清单<span v-show="buyType === 1" @click.stop.prevent="cReturnCart">[返回购物车修改]</span></div> -->
        <div
          v-for="(sItem, sIndex) of storeProduct"
          :key="sIndex"
          :style="'margin-top:' + (sIndex ? 100: 10) + 'px;'"
        >
          <div class='shopname'>店铺id：{{sItem.storeId}} 店铺名称：{{sItem.storeName}}{{judge(sItem.sourceFlag)}}</div>
          <table
            cellspacing="0"
            cellpadding="3"
            width="100%"
          >
            <tr class="thead">
              <th
                v-for="item of list_th"
                :key="item"
              >{{item}}</th>
            </tr>

            <template v-for="(brandProducts, brandId) in sItem.brandProductList">
              <tr
                v-for="item in brandProducts"
                v-if="item.isCheck"
                :key="item.goodsId"
              >
                <td @click.stop.prevent="cGoods(item.goodsId)"><img
                    :src="item.imageDefault"
                    alt="购物车商品海报"
                  ></td>
                <td
                  class="name"
                  @click.stop.prevent="cGoods(item.goodsId)"
                >{{item.name || item.goodName}}</td>
                <td>￥{{item.disPrice > 0 ? returnFloat(item.disPrice || item.discountPrice) : '0.00'}}</td>
                <td>￥{{returnFloat(item.coupPrice || item.couponPrice)}}</td>
                <td>{{item.num}}</td>
                <td>￥{{returnFloat(item.num*(item.coupPrice || item.couponPrice))}}</td>
              </tr>
              <tr>
                <td
                  colspan=6
                  style="overflow: auto; width: 100%; padding: 0 5px;"
                >
                  <div class="ways">
                    <span style="text-align:center">配送方式：</span>
                    <Select
                      v-for="(wItem, wIndex) of ways"
                      v-if="currWay[sItem.storeId] && wItem.storeId == sItem.storeId && (!Number(brandId) || wItem.brandId == brandId)"
                      v-model="currWay[sItem.storeId][brandId]"
                      :key="wItem.storeId + wIndex"
                      slot="prepend"
                      style="width: 252px"
                    >
                      <Option
                        v-for="(child, childIdx) of wItem.shippingList"
                        :value="child.shipId"
                        :key="child.shipId"
                        @click.native="chooseWays(sIndex, brandId, childIdx)"
                      >{{child.shipName || child.shipDesc}}
                      </Option>
                    </Select>
                  </div>
                </td>
              </tr>
            </template>
          </table>

          <div class="other">
            <div class="all-price">
              <!-- totalSumAll -->
              <!-- amount(sItem,postage[sIndex]) -->
              <span>店铺总计：</span><span>￥<em style='color: #4b4c4c;    font-weight: bold;'>{{amount(sItem,postage[sIndex])}}</em>元</span>
            </div>
            <div class="remark">
              <span>订单备注：</span>
              <textarea
                v-model="remark[sIndex]"
                style="width: 378px;height:55px;line-height: 20px; margin-top:5px; resize:none;"
              ></textarea>
              <div class="tip">*请勿填写有关支付/收货/发票方面的信息，如有特殊需要请联系客服人员。</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 送货时间和发票 -->
      <div class="time-order">
        <div class="delivery-time">
          <span>送货时间：</span>
          <Select
            v-model="deliveryTime"
            slot="prepend"
            style="width: 80px"
          >
            <Option value="任意日期">任意日期</Option>
            <Option value="仅工作日">仅工作日</Option>
            <Option value="仅休息日">仅休息日</Option>
          </Select>
        </div>
        <div class="invoice">
          <input
            type="checkbox"
            id="invoice"
            value="invoice"
            v-model="invoice.need"
          >
          <label for="invoice">索取发票</label>
          <div
            v-show="invoice.need"
            class="content"
          >
            <div>
              <span>发票抬头</span>
              <input
                type="radio"
                id="one"
                value="One"
                v-model="invoice.raised"
              >
              <label for="one">个人</label>
              <input
                type="radio"
                id="two"
                value="Two"
                v-model="invoice.raised"
              >
              <label for="two">单位</label>
              <Input
                class="info"
                v-model="invoice.title"
                v-show="invoice.raised === 'Two'"
              ></Input>
            </div>
            <div>
              <span>发票内容</span>
              <select
                class='bill-list'
                v-model="invoice.type"
              >
                <option>办公用品</option>
                <option>劳保用品</option>
                <option>耗材</option>
              </select>
            </div>
            <div>发票在您收到货30天后通过平邮寄出，请注意查收</div>
            <div class="warning">注：内容不全默认为不索取发票</div>
          </div>
        </div>
        <div
          class="btn-order"
          @click.stop.prevent="cOrder"
        >提交订单</div>
      </div>
    </div>
    <!-- 新建地址弹框 -->
    <address-modal
      v-show="isShowAddreModal"
      :isShowAddreModal.sync="isShowAddreModal"
      :getAddressList="getAddressList"
    >
    </address-modal>
  </div>
</template>
<script>
import addressModal from "@/views/shopping-cart/addressModal";
import { freight, createOrder } from "api/goodsCart";
import { isDelivery } from "api/goods";
import { addressList, getMyPoint } from "api/user";
import { getSession } from "utils/tool";
import { getGoodsList } from "@/api/goods";
import { mapGetters } from "vuex";
export default {
  name: "checkout",
  components: {
    addressModal,
  },
  data() {
    return {
      isShowInfo: false, // 判断是否出厂家商品显示弹出框标识
      isShowAddreModal: false, // 新增地址是否显示
      isMoreAddr: false, //超过四条地址则显示更多地址按钮
      isActive: false, //改变地址框高度
      goods: {}, // 商品信息
      storeProduct: [], // 根据店铺分类
      checkids: "", // 选中的购物车id
      checkidsArray: [], // 结算商品id数组
      couponLimit: 0, // 可使用最大优惠券额度
      selfShoppingPv: 0, // 自营购物积分
      usedSelfShoppingPv: 0, // 使用的自营购物积分
      checkAtTheShoppingPv: 0, // 同时勾选现金券和自营购物积分时的自营购物积分
      chainGoodsProfit: 0, // 供应链商品利润价格
      couponUsed: true, // 是否使用优惠券
      selfShoppingPvFlag: true, // 是否自营积分
      usedCoupon: 0, // 使用的优惠券额度
      myCoupon: 0, // 我的优惠券额度
      mySignRebate: 0, // 我的自营购物积分
      currAddre: {}, // 当前地址
      currAddreId: "", // 当前地址id
      regionId: "", // 省id
      addressList: [], // 地址列表
      currentIndex: 0, //默认标记
      sureEdit: true, // 是否确认地址信息
      default: false,
      list_th: ["图片", "商品名称", "优惠价格", "销售价格", "数量", "小计"],
      remark: [], // 订单备注
      deliveryTime: "任意日期", // 送货时间
      ways: [], // 配送方式
      currWay: {}, // 当前配送方式方式
      postage: [], // 邮费
      invoice: {
        // 发票
        need: false, // 是否需要发票
        raised: "One", // 发票抬头
        title: "",
        type: "办公用品", // 商品分类
      },
      countryName: "", // 乡镇名字
      brandId: "",
      buyType: 1,
    };
  },
  computed: {
    // 获取购物车
    ...mapGetters({
      cartProducts: "cartProducts",
      cartTotalPrice: "cartTotalPrice",
    }),
    //计算合计
    totalSumAll() {
      let totalMoney = 0;
      this.storeProduct.map((item, index) => {
        if (!isNaN(item.store_all_price)) {
          totalMoney += item.store_all_price + this.postage[index] || 0;
        }
        if (isNaN(totalMoney)) {
          return 0;
        }
      });
      if (this.couponUsed) {
        totalMoney -= this.couponLimit ? this.couponLimit : 0;
      }
      if (this.selfShoppingPvFlag) {
        totalMoney -= this.usedSelfShoppingPv
          ? Number(this.usedSelfShoppingPv)
          : 0;
      }
      return totalMoney.toFixed(2);
    },
  },
  created() {
    if (!this.$route.query.checkIds) {
      // 立即购买
      console.log("立即购买");
      this.storeId = this.$route.query.storeId; // 店铺id
      this.goodsId = this.$route.query.goodsId; // 商品id
      this.buyNum = Number(this.$route.query.num); // 购买数量
      //this.checkids = this.$route.query.itemId // 商品结算id
      this.couponLimit = this.$route.query.couponLimit
        ? Number(this.$route.query.couponLimit) * this.buyNum
        : 0;
      this.selfShoppingPv =
        this.$route.query.selfShoppingPv || this.$route.query.selfRunShoppingPv
          ? Number(
              this.$route.query.selfShoppingPv ||
                this.$route.query.selfRunShoppingPv
            )
          : 0;
      this.checkAtTheShoppingPv = this.$route.query.checkAtTheShoppingPv;
      // this.chainGoodsProfit = this.$route.query.chainGoodsProfit;
      // if (this.$route.query.source_flag) this.sourceFlag = this.$route.query.source_flag;
      // else this.sourceFlag = '0';
      this.buyType = 2; // 购买方式
      this.getInfo();
    } else {
      console.log("非立即购买");
      console.log(this.cartProducts, "this.cartProducts");
      // 从购物车流程过来
      this.buyType = 1;
      this.checkids = this.$route.query.checkIds; // 商品结算id
      this.couponLimit = this.$route.query.couponLimit
        ? Number(this.$route.query.couponLimit)
        : 0;
      this.selfShoppingPv =
        this.$route.query.selfShoppingPv || this.$route.query.selfRunShoppingPv
          ? Number(
              this.$route.query.selfShoppingPv ||
                this.$route.query.selfRunShoppingPv
            )
          : 0;
      this.checkAtTheShoppingPv = this.$route.query.checkAtTheShoppingPv;
      this.chainGoodsProfit = this.$route.query.chainGoodsProfit;
      if (this.$route.query.source_flag) {
        this.sourceFlag = this.$route.query.source_flag;
      } else {
        this.sourceFlag = "0";
      }

      if (this.checkids.split(",").length === 1) {
        this.checkidsArray[0] = this.checkids;
      } else {
        this.checkidsArray = this.checkids.split(",");
      }

      // 重新设置结算的商品（避免刷新时购物车重新请求，导致isCheck为false）
      let timer = setInterval(() => {
        if (this.cartProducts.length > 0) {
          // 遍历结算id数组
          for (let i = 0; i < this.checkidsArray.length; i++) {
            // 从购物车匹配对应的商品
            for (let item of this.cartProducts) {
              // 筛选结算的商品
              if (item.itemId == this.checkidsArray[i]) {
                item.isCheck = true;
                // 根据店铺进行整理
                if (this.storeProduct.length === 0) {
                  this.storeProduct = this.storeProduct.concat({
                    storeId: item.storeId,
                    storeName: item.storeName,
                    sourceFlag: item.sourceFlag,
                    store_all_price:
                      item.num * (item.coupPrice || item.couponPrice),
                    list: [item],
                    brandProductList: {},
                    useCoupon: item.num * item.useCoupon, //店铺可用现金劵
                    selfShoppingPv:
                      item.num *
                      (item.selfRunShoppingPv || item.selfShoppingPv), //店铺可用自营积分
                  });
                } else {
                  // 遍历店铺，将商品匹配到对应的店铺中
                  for (let index in this.storeProduct) {
                    if (item.storeId == this.storeProduct[index].storeId) {
                      this.storeProduct[index].list =
                        this.storeProduct[index].list.concat(item);
                      this.storeProduct[index].store_all_price +=
                        item.num * (item.coupPrice || item.couponPrice);
                      this.storeProduct[index].useCoupon +=
                        item.num * item.useCoupon;
                      this.storeProduct[index].selfShoppingPv +=
                        item.num *
                        (item.selfRunShoppingPv || item.selfShoppingPv);
                      break;
                    } else if (
                      item.storeId != this.storeProduct[index].storeId &&
                      index == this.storeProduct.length - 1
                    ) {
                      // 若最后一个还没匹配到，则新建店铺
                      this.storeProduct = this.storeProduct.concat({
                        storeId: item.storeId,
                        storeName: item.storeName,
                        sourceFlag: item.sourceFlag,
                        store_all_price:
                          item.num * (item.coupPrice || item.couponPrice),
                        list: [item],
                        brandProductList: {},
                        useCoupon: item.num * item.useCoupon,
                        selfShoppingPv:
                          item.num *
                          (item.selfRunShoppingPv || item.selfShoppingPv),
                      });
                      break;
                    }
                  }
                }
                //console.log(this.storeProduct)
              }
            }
          }

          console.log(this.storeProduct, "*******************");

          this.processStoreProduct();

          clearInterval(timer);
        }
      }, 50);
    }
    this.getSelfShoppingPv();
    this.getAddressList();
    this.getMyPointData();
  },
  methods: {
    //获取运费模板
    processStoreProduct() {
      for (const i in this.storeProduct) {
        console.log(this.storeProduct, "this.storeProduct");
        // 按照品牌信息排序，保证有品牌的排在前
        this.storeProduct[i].list.sort((a, b) => b.brandId - a.brandId);

        const firstProduct = this.storeProduct[i].list[0];
        let currentBrandId = firstProduct.isSelfRunStore
          ? firstProduct.brandId || ""
          : "";

        for (const o in this.storeProduct[i].list) {
          const product = this.storeProduct[i].list[o];
          const brandId = product.isSelfRunStore ? product.brandId || "" : "";

          // 遍历按品牌进行分组
          if (currentBrandId && brandId) {
            if (currentBrandId === brandId) {
              if (!this.storeProduct[i].brandProductList[brandId]) {
                this.storeProduct[i].brandProductList[brandId] = [product];
              } else {
                this.storeProduct[i].brandProductList[brandId].push(product);
              }
            } else {
              currentBrandId = brandId;
              this.storeProduct[i].brandProductList[brandId] = [product];
            }
          } else {
            // 品牌不存在的商品就放置于0这个默认的下面
            if (!this.storeProduct[i].brandProductList[0]) {
              this.storeProduct[i].brandProductList[0] = [product];
            } else {
              this.storeProduct[i].brandProductList[0].push(product);
            }
          }
        }
      }

      this.initPostage();
    },

    judge(flag) {
      if (+flag === 3) {
        this.isShowInfo = true;
      }
    },

    // 获取用户优惠券额度
    getMyPointData: function () {
      getMyPoint({ loginName: getSession("userName") }).then((json) => {
        this.myCoupon = json.data.coupon;
        this.mySignRebate = json.data.signRebate;
      });
    },
    // 获取商品信息，用户立即购买方式获取商品信息
    getInfo() {
      getGoodsList({
        goodsId: this.goodsId,
        platfrom: 0,
      }).then((res) => {
        if (res.resCode === 1) {
          let poster;
          // 设置海报图片
          if (!res.data.goodsGalleryList[0]) {
            poster = res.data.thumbnail;
          } else {
            poster = res.data.goodsGalleryList[0].small;
          }

          this.sourceFlag = res.data.sourceFlag || "0";
          if (this.sourceFlag == 2) {
            this.couponLimit =
              Number(res.data.couponAmountByChain) * this.buyNum;
          } else {
            this.couponLimit = Number(res.data.couponAmount) * this.buyNum;
          }
          this.selfShoppingPv = Number(
            res.data.selfShoppingPv || res.data.selfRunShoppingPv
          );

          // this.storeId = res.data.storeId // 店铺id
          // this.goodsId = res.data.goods_id; // 商品id
          // this.buyNum = res.data.buyNum; // 购买数量

          // 整理店铺和商品信息
          this.storeProduct = this.storeProduct.concat({
            storeId: res.data.storeId,
            storeName: res.data.storeName,
            sourceFlag: res.data.sourceFlag,
            store_all_price:
              res.data.goodsType === "batch"
                ? this.buyNum * res.data.batchPrice
                : this.buyNum * res.data.price,
            list: [
              {
                isCheck: true,
                goodsId: this.goodsId,
                imageDefault: poster,
                name: res.data.name,
                isSelfRunStore: res.data.isSelfRunStore,
                brandId: res.data.brandId,
                num: this.buyNum,
                selfShoppingPv:
                  res.data.selfShoppingPv || res.data.selfRunShoppingPv,
                disPrice:
                  res.data.mktprice -
                  (res.data.goodsType === "batch"
                    ? res.data.batchPrice
                    : res.data.price),
                coupPrice:
                  res.data.goodsType === "batch"
                    ? res.data.batchPrice
                    : res.data.price,
              },
            ],
            brandProductList: {},
            useCoupon:
              this.buyNum *
              (res.data.couponAmount
                ? res.data.couponAmount
                : res.data.couponAmountByChain), //店铺可用现金劵
            selfShoppingPv:
              this.buyNum *
              (res.data.selfShoppingPv || res.data.selfRunShoppingPv), //店铺可用自营积分
          });

          this.processStoreProduct();
        }
      });
    },
    // 获取地址列表
    getAddressList() {
      addressList().then((res) => {
        if (res.resCode === 1) {
          if (!res.data) {
            this.isShowAddreModal = true;
            this.sureEdit = false;
          } else {
            this.addressList = res.data;
            if (res.data.length > 4) {
              this.isMoreAddr = true;
            }
            // 设置默认地址
            let arr = [];
            res.data.map((item) => {
              if (item.defaultAddress === 1) {
                arr.push(item);
              }
            });
            if (res.data.length == 1) {
              arr = res.data;
            }
            //判断是否有默认地址  arr 有值就是有默认地址
            if (arr.length > 0) {
              this.currAddreId = arr[0].addressId;
              this.regionId = arr[0].regionId;
              this.currAddre = arr[0];
              this.countryName = arr[0].countyName;
              this.getFreight();
            } else {
              this.currAddreId = res.data[0].addressId;
              this.regionId = res.data[0].regionId;
              this.currAddre = res.data[0];
              this.getFreight();
            }
          }
        }
      });
    },
    // 获取运费数据
    getFreight() {
      let params = {
        addrId: Number(this.currAddre.addressId),
      };
      // 根据不同购买方式配置请求参数
      if (this.buyType === 2) {
        params.goodsNum = Number(this.buyNum);
        params.goodsId = this.goodsId;
      } else {
        params.cartIds = this.checkids.split(",");
      }
      // 运费请求
      freight(params).then((res) => {
        if (res.resCode === 1) {
          this.ways = res.data;
          if (this.buyType === 2) {
            this.brandId = this.ways[0].brandId;
          }
          this.postage = [];
          this.initPostage();
        } else {
          this.$Message.warning(res.resDesc);
          //如果找不到购物车商品 说明itemId过期了（跳转到购物车页面）
          if (/未找到购物车商品/.test(res.resDesc)) {
            window.location.href = "/shopping-cart";
          }
        }
      });
    },
    initPostage() {
      if (
        !this.storeProduct.length ||
        !this.ways.length ||
        this.postage.length
      ) {
        return;
      }

      // 清除旧数据
      this.postage = [];
      this.currWay = {};

      this.storeProduct.forEach((store, index) => {
        this.postage[index] = 0;

        if (!this.currWay[store.storeId]) {
          this.currWay[store.storeId] = {};
        }

        for (const brandId in store.brandProductList) {
          const targetWay = this.ways.find(
            (way) =>
              way.storeId == store.storeId &&
              (!Number(brandId) || brandId == way.brandId)
          );
          if (targetWay) {
            this.postage[index] += Number(targetWay.shippingList[0].shipPrice);
            if (!this.currWay[store.storeId][brandId]) {
              this.currWay[store.storeId][brandId] =
                targetWay.shippingList[0].shipId;
            }
          }
        }
      });
    },

    // 选择配送方式，计算邮费，以店铺为标准
    chooseWays(storeIdx, selectBrandId, childIdx) {
      const store = this.storeProduct[storeIdx];

      let postage = 0;
      for (const brandId in store.brandProductList) {
        const targetWay = this.ways.find(
          (way) =>
            way.storeid == store.storeId &&
            (!Number(brandId) || brandId == way.brandId)
        );
        if (targetWay) {
          postage += Number(
            targetWay.shiplist[brandId == selectBrandId ? childIdx : 0]
              .ship_price
          );
        }
      }

      this.$set(this.postage, storeIdx, postage);
    },
    // 设置当前选中地址
    checkAddre(value, index, name, currentItem) {
      this.countryName = name;
      this.ways = [];
      this.currAddreId = value;
      this.regionId = currentItem.regionId;
      this.addressList.map((item) => {
        if (item.addressId == value) {
          this.currAddre = item;
          this.currentIndex = index;
          this.sureEdit = true;
          // 重新获取邮费数据
          this.getFreight();
        }
      });
    },
    // 显示新增地址弹框
    cAddAddress() {
      this.isShowAddreModal = true;
      $(".address-modal input[type=text]").val("");
    },
    /**
     * [cSureEdit 确认或编辑收货地址]
     * @param  {[String]} type [确认或修改，sure确认，edit修改]
     */
    cSureEdit(type) {
      if (type === "sure") {
        //判断当前有无地址
        if (this.currAddreId) {
          this.sureEdit = true;
        } else {
          this.$Modal.error({
            content: "请添加至少一个收货地址",
            onOk: () => {},
          });
        }
      } else {
        this.sureEdit = false;
      }
    },
    // 返回购物车修改
    cReturnCart() {
      this.$router.go(-1);
    },
    // 点击商品
    cGoods(id) {
      this.$router.push({ path: "/goods", query: { goods_id: id } });
    },
    showMoreAddr() {
      this.isActive = !this.isActive;
    },
    /**
     * [createOrder 创建订单]
     * @param  {[storeids]} String [店铺id字符串组合]
     * @param  {[itemids]} String [商品id字符串组合]
     * @param  {[remarks]} String [店铺对应留言字符串组合]
     */
    createOrder(storeids, itemids, remarks) {
      remarks = JSON.parse(remarks.replace(/\n/g, "<br/>"));
      // location.href = '//103.235.254.233:8081/api/b2b2c/storePaymentApi.do?orderid=12671'
      // 判断在使用优惠券的情况下，使用额度是否超限
      if (
        this.couponLimit > 0 &&
        parseFloat(this.myCoupon) &&
        this.couponUsed &&
        parseFloat(this.usedCoupon) > parseFloat(this.myCoupon)
      ) {
        confirm("使用的优惠券金额超出余额");
        return;
      }
      // if (this.couponUsed && parseFloat(this.usedCoupon) > parseFloat(this.couponLimit)) {
      //   confirm('使用的优惠券金额超出此次订单最大可用额度')
      //   return
      // }

      let tempwindow = window.open("about:blank", "_blank");

      // 构造邮寄信息
      const shippingInfos = [];
      for (const storeId in this.currWay) {
        for (const brandId in this.currWay[storeId]) {
          const options = {
            shipId: Number(this.currWay[storeId][brandId]),
            storeId: Number(storeId),
            brandId: this.buyType == 2 ? this.brandId : Number(brandId),
          };
          shippingInfos.push(options);
        }
      }
      console.log(this.currWay);
      const orderInfo = {
        ships: shippingInfos,
        addrId: Number(this.currAddre.addressId),
        shipDay: this.deliveryTime,
        remarks: [],
        shareName: "",
        coupon: 0,
        selfShoppingPv: 0,
        receipt: {
          receiptContent: this.invoice.type,
          receiptTitle: this.invoice.title,
          receiptType: this.invoice.need
            ? this.invoice.raised == "Two"
              ? 2
              : 1
            : 0,
        },
      };
      for (let key in remarks) {
        orderInfo.remarks.push({
          remark: remarks[key],
          storeId: Number(key.split("_")[1]),
        });
      }
      // 根据不同购买方式配置请求参数
      if (this.buyType === 2) {
        orderInfo.goodsNum = Number(this.buyNum);
        orderInfo.goodsId = Number(this.goodsId);
      } else {
        orderInfo.cartIds = this.checkids.split(",");
      }
      if (this.couponUsed) {
        // 使用的优惠券，则新增参数
        orderInfo.coupon = this.couponLimit ? this.couponLimit : 0;
      }

      if (this.selfShoppingPvFlag) {
        // 使用自营购物积分，则新增参数
        orderInfo.selfShoppingPv = this.usedSelfShoppingPv
          ? this.usedSelfShoppingPv
          : 0;
      }
      createOrder(orderInfo, this.buyType)
        .then((res) => {
          if (+res.resCode === 1) {
            // 结算成功后重新计算购物车数量 高春超 2018年3月16日20:49:25
            this.$store.dispatch("getCartList");
            let routeData = this.$router.resolve({
              path: "/pay",
              query: { orderId: res.data.orderId, orderNo: res.data.orderNo },
            });
            // 跳转到pay进行结算
            tempwindow.location = routeData.href;
            setTimeout(() => {
              this.$router.go(-1);
            }, 5000);
          } else {
            this.$Message.warning({
              content: res.resDesc,
              duration: 4,
            });
            tempwindow.close();
          }
        })
        .catch(tempwindow.close);
    },
    // 点击结算订单
    cOrder() {
      // 确认收货人
      if (!this.sureEdit) {
        confirm("请确认收货人信息");
        return;
      }
      if (!this.countryName) {
        this.$Modal.info({
          title: "温馨提示",
          content: "您选择的地址需要重新编辑后才能提交订单",
          onOk: () => {
            this.$router.push("/member/address");
          },
        });
        return;
      }
      let goodsIds = [];
      this.storeProduct.forEach((item) => {
        item.list.forEach((v) => {
          goodsIds.push(v.goodsId);
        });
      });
      // 判断是否可以发货
      isDelivery({
        goodsIds: this.goodsId ? [this.goodsId] : goodsIds,
        regionId: this.regionId,
      }).then((res) => {
        if (res.resCode == 1) {
          let goodsList = [];
          let isDelivery = [];
          res.data.forEach((item) => {
            goodsList.push(item.deliveryDTOList);
          });
          console.log(goodsList, "goodsList");
          goodsList.forEach((item) => {
            item.forEach((v) => {
              isDelivery.push(v.isDelivery);
            });
          });
          console.log(isDelivery, "isDelivery--------");
          let flag = isDelivery.every((a, b, c) => {
            return a == "1";
          });
          // flag 为true 通过，否则不通过
          if (flag) {
            let item = this.currAddre;
            this.$Modal.confirm({
              title: "请确认订单",
              content:
                "<p>" +
                item.consigneeName +
                "  " +
                item.mobile +
                "</p><br/>" +
                "<p>" +
                item.province +
                "  " +
                item.city +
                "  " +
                item.region +
                "  " +
                item.address +
                "</p><br/>" +
                '<p>合计：<strong style="color:red;font-size:16px;">¥' +
                this.totalSumAll +
                "</strong></p>",
              okText: "确认收货信息",
              closable: true,
              onOk: () => {
                if (this.buyType === 2) {
                  // 立即购买情况
                  let currRemark =
                    '{"remark_' +
                    this.storeId +
                    '":"' +
                    (this.remark.length > 0 ? this.remark[0] : "") +
                    '"}';
                  // 判断在使用优惠券的情况下，使用额度是否超限
                  console.log(this.couponLimit, this.myCoupon, "999999999999");

                  if((this.couponLimit == 0 || this.usedSelfShoppingPv == 0) && parseFloat(this.myCoupon) == 0) {
                    this.couponUsed = false
                    this.selfShoppingPvFlag = false
                  }

                  if (
                    this.couponUsed &&
                    parseFloat(this.couponLimit) > parseFloat(this.myCoupon)
                  ) {
                    confirm("使用的优惠券金额超出余额");
                    return;
                  }
                  this.createOrder(this.storeId, this.checkids, currRemark);
                } else {
                  // 从购物车来结算情况
                  // 设置请求参数
                  let storeids = ""; // 店铺id
                  let itemids = ""; // 商品idid
                  let remarks = "{"; // 留言
                  // 遍历店铺，设置对应参数
                  this.storeProduct.map((sItem, sIndex) => {
                    let currRemark = !this.remark[sIndex]
                      ? ""
                      : this.remark[sIndex];
                    // 最后一个店铺
                    if (sIndex === this.storeProduct.length - 1) {
                      storeids += sItem.storeId;
                      if (this.storeProduct.length === 1) {
                        // 只有一个商品
                        remarks =
                          '{"remark_' +
                          sItem.storeId +
                          '":"' +
                          currRemark +
                          '"}';
                      } else {
                        // 最后一个商品
                        remarks +=
                          '"remark_' +
                          sItem.storeId +
                          '":"' +
                          currRemark +
                          '"}';
                      }
                    } else {
                      // 获取并设置店铺相关参数
                      storeids += sItem.storeId + ",";
                      remarks +=
                        '"remark_' + sItem.storeId + '":"' + currRemark + '",';
                    }
                    // 遍历店铺中的商品。设置商品id
                    sItem.list.forEach((lItem, lIndex) => {
                      if (lIndex === sItem.list.length - 1) {
                        itemids += lItem.itemId;
                        if (sIndex === this.storeProduct.length - 1)
                          this.createOrder(storeids, itemids, remarks);
                      } else {
                        itemids += lItem.itemId + ",";
                      }
                    });
                    itemids += ",";
                  });
                }
              },
              cancelText: "取消",
              onCancel: () => {},
            });
          } else {
            this.$Message.warning(
              "当前收货地址有店铺商品不在配送区域内，不能下单"
            );
          }
        } else {
          this.$Message.warning(res.data || res.resDesc);
        }
      });
    },
    // 初始化价格格式
    returnFloat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    clickCoupon() {
      // if (!this.couponUsed && this.totalSumAll < this.couponLimit) {
      //   this.selfShoppingPvFlag = false
      // }
      this.couponUsed = !this.couponUsed;
    },
    clickSelfShoppingPv() {
      //使用现金劵和自营积分额度不能大于计算商品总额
      // if (!this.selfShoppingPvFlag && this.totalSumAll < this.usedSelfShoppingPv) {
      //   this.couponUsed = false
      // }
      this.selfShoppingPvFlag = !this.selfShoppingPvFlag;
      this.getSelfShoppingPv();
    },
    getSelfShoppingPv() {
      this.usedSelfShoppingPv = this.selfShoppingPvFlag
        ? this.checkAtTheShoppingPv
        : this.checkAtTheShoppingPv;
    },
    //店铺合计金额计算，先计算商品总金额
    //在判断商品可用现金劵的金额是否大于订单可用现金劵的金额
    //在判断可用积分 同上
    amount(sItem, postage) {
      let money = this.returnFloat(sItem.store_all_price + (postage || 0)),
        coupon = 0,
        selfshop = 0;
      if (this.couponUsed && this.couponLimit) {
        if (this.couponLimit < sItem.useCoupon) {
          coupon = this.couponLimit;
        } else {
          coupon = sItem.useCoupon;
        }
      }
      if (this.selfShoppingPvFlag && this.usedSelfShoppingPv) {
        if (
          this.usedSelfShoppingPv <
          (sItem.selfShoppingPv || sItem.selfRunShoppingPv)
        ) {
          selfshop = this.usedSelfShoppingPv;
        } else {
          selfshop = sItem.selfShoppingPv || sItem.selfRunShoppingPv;
        }
      }
      return (
        money -
        this.returnFloat(coupon) -
        this.returnFloat(selfshop)
      ).toFixed(2);
    },
  },
};
</script>
<style lang="less" type="text/less" scoped>
.checkout {
  width: 980px;
  overflow: hidden;
  margin: 0px auto;
}

.cart-nav {
  width: 980px;
  height: 69px;
  overflow: hidden;
  border-top: 1px solid #e7e8e4;

  image {
    width: 980px;
    height: 69px;
  }
}

.content {
  clear: both;
  width: 976px;
  margin-bottom: 20px;
  border: 2px solid #d5d5d5;
  padding-bottom: 40px;
  .shopname {
    line-height: 40px;
    font-size: 12px;
    color: #666;
    font-weight: 600;
  }
  .address {
    /* background-color: #ececee; */

    .title {
      width: 946px;
      height: 34px;
      line-height: 34px;
      padding-left: 30px;
      color: #333;
      font-weight: bold;

      span {
        color: #9d9d9d;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .item {
      clear: both;
      line-height: 25px;
      width: 856px;
      display: block;
      margin-left: 30px;
      padding: 6px;
    }

    .btn {
      border-bottom: 1px dashed #bebebe;
      padding: 10px 0px 23px 61px;
      margin: 0px;
      width: 915px;
      height: 33px;

      span {
        display: inline-block;
        text-align: center;
        border: 0px none;
        width: 110px;
        height: 33px;
        line-height: 33px;
        overflow: hidden;
        margin-left: 10px;
        cursor: pointer;
        padding: 0px;
        font-size: 14px;
        font-weight: bold;
      }

      .add-address {
        color: #000;
        background: url(//static.kxymall.com/images/qrfkfs.jpg) no-repeat left
          top;

        &:hover {
          // background-position: -138px -138px;
        }
      }

      .btn-sure-info {
        color: #fff;
        background: url(//static.kxymall.com/images/jshop_button.jpg);
        background-position: left -138px;

        &:hover {
          background-position: -138px -138px;
        }
      }
    }

    .sure-info {
      color: #333;
      padding-left: 60px;
      padding-bottom: 10px;
      display: block;
    }

    .payment {
      /*  padding-left: 30px; */
      color: #333;

      > div:first-child {
        width: 946px;
        height: 34px;
        line-height: 34px;
        color: #333;
        font-weight: bold;
      }

      > div:nth-child(2) {
        color: #333;
        /*  padding-left: 30px; */
        width: 916px;
        line-height: 34px;
      }

      .way {
        /*  padding-left: 30px; */
        width: 916px;
        line-height: 28px;
      }
    }
  }

  .list {
    padding: 10px 30px;

    .title {
      height: 38px;
      line-height: 38px;
      color: #333;

      span {
        display: inline-block;
        float: right;
        color: #9d9d9d;
        cursor: pointer;
      }
    }

    table {
      border-collapse: collapse;
      border-spacing: 0;

      tr.thead {
        /*           width: 980px;
height: 35px;
background-color: #ececee; */
        line-height: 41px;
        height: 42px;
        color: #999;
        background: #f5f5f5;

        th {
          padding-left: 5px;
          color: #666;
          font-weight: normal;
          /*  border-bottom: 1px dashed #BEBEBE; */
          font-weight: bold;
          text-align: left;
        }
      }

      tr {
        td {
          overflow: hidden;
          border-bottom: 1px dashed #bebebe;
          width: 135px;
          vertical-align: middle;
          padding: 10px 5px;
          border-bottom: 1px dashed #bebebe;

          img {
            width: 50px;
            height: 50px;
            cursor: pointer;
          }
        }

        td.name {
          width: 155px;
          cursor: pointer;

          &:hover {
            color: #f60;
          }
        }
      }
    }

    .other {
      line-height: 60px;
      height: 95px;

      .remark {
        /*margin-top: -80px;*/
        text-align: left;

        .tip {
          line-height: 20px;
          margin-left: 60px;
          margin-top: -6px;
        }
      }

      .all-price {
        text-align: right;

        > span {
          display: inline-block;
          text-align: left;
          color: #4b4c4c;
        }
        span:first-child {
          width: 150px;
          font-weight: bold;
        }

        span:last-child {
          width: 147px;
          font-weight: bold;
          font-size: 14px;
        }
      }
    }

    .ways {
      text-align: right;
      height: 60px;
      line-height: 60px;
      width: 100%;
      overflow: auto;

      > span {
        color: #4b4c4c;
      }
    }
  }

  .time-order {
    margin-top: 90px;

    .invoice {
      margin-top: 20px;
      margin-left: 30px;
      .content {
        padding: 10px 0px;
        background-color: #fefbf4;
        padding-left: 30px;
        width: 417px;
        border: none;
        border-top: 1px solid #eae7e0;
        border-bottom: 1px solid #eae7e0;
        line-height: 32px;

        .warning {
          width: 377px;
          clear: both;
          height: 30px;
          color: #c00;
          background-color: #ffc;
          padding: 6px;
          margin: 6px 0;
          border: 1px dashed #f90;
        }
      }
    }
  }

  .delivery-time {
    padding: 0px 30px;
  }

  .btn-order {
    display: block;
    text-align: center;
    border: 0px none;
    width: 110px;
    height: 33px;
    line-height: 32px;
    float: right;
    overflow: hidden;
    margin: -3px 62px 0px 0px;
    cursor: pointer;
    padding: 0px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    /* color: #fff; */
    background: url(//static.kxymall.com/images/jshop_button.jpg);
    background-position: left -88px;

    &:hover {
      background-position: -138px -88px;
    }
  }
}
.invoice input {
  display: inline-block;
  vertical-align: middle;
}

.same_module {
  padding-top: 10px;
}
.consignee_adr {
}
.wrap {
  width: 976px;
  margin: 0 auto;
}
.mod_rel_head {
  position: relative;
  height: 30px;
  .mr_tit {
    display: inline-block;
    float: left;
    height: 14px;
    margin-top: 8px;
    line-height: 14px;
    font-size: 14px;
    color: #333;
    border-left: 3px solid #d93600;
    text-indent: 12px;
  }
  .mr_ctrlbtn {
    display: inline-block;
    float: right;
    height: 20px;
    padding: 5px 2px;
    color: #0066cc;
  }
}
.same_module_rel {
  padding: 10px 29px;
  background-color: #fff;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  .consign_rel_cont {
    padding: 10px 0px;
    overflow: hidden;
    > ul {
      width: 110%;
      height: 120px;
      overflow: hidden;
      li {
        position: relative;
        float: left;
        width: 190px;
        height: 106px;
        padding: 0px 10px;
        margin-right: 23px;
        margin-bottom: 12px;
        border: 1px solid #e5e5e5;
        -moz-border-radius: 2px;
        -webkit-border-radius: 2px;
        border-radius: 2px;
        cursor: pointer;
      }
    }
    .total_info {
      height: 28px;
      line-height: 28px;
      border-bottom: 1px dashed #e6e6e6;
      .adr_icon {
        display: inline-block;
        width: 18px;
        height: 16px;
        margin-top: 5px;
        margin-right: 5px;
        background-position: -18px -2px;
      }
      .tot_name {
        font-weight: bold;
        color: #666;
      }
      .init_adrs {
        float: left;
        padding: 0px 4px;
        margin-top: 4px;
        margin-left: 8px;
        height: 18px;
        border-radius: 1px;
        line-height: 18px;
        background-color: #fff4f4;
        border: 1px solid #ffdbdb;
        color: #ff5e5e;
      }
      .tot_edit a {
        margin-left: 4px;
        color: #0066cc;
      }
    }
    .detail_info {
      padding-top: 6px;
      p {
        height: 22px;
        line-height: 22px;
        color: #666;
        white-space: nowrap;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .is_choose {
      visibility: hidden;
      position: absolute;
      right: -1px;
      bottom: 0;
      width: 17px;
      height: 18px;
      background-position: 0 0;
    }
    .cng_more {
      position: relative;
      display: block;
      width: 66px;
      height: 20px;
      line-height: 20px;
      color: #999;
      cursor: pointer;
      > em {
        position: absolute;
        right: 0;
        top: 4px;
        width: 12px;
        height: 12px;
        background-position: 0px -20px;
      }
      .sprite_odr {
        font-size: 0px;
        line-height: 0;
        vertical-align: middle;
        display: inline-block;
        width: 0px;
        height: 0px;
        margin-left: 8px;
        margin-top: 4px;
        border-width: 4px;
        border-color: #777 transparent transparent transparent;
        border-style: solid dashed dashed dashed;
      }
      .sprite_odrs {
        font-size: 0px;
        line-height: 0;
        vertical-align: middle;
        display: inline-block;
        width: 0px;
        height: 0px;
        margin-left: 8px;
        margin-top: 0;
        border-width: 4px;
        border-color: #777 transparent transparent transparent;
        border-style: solid dashed dashed dashed;
        transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        -o-transform: rotate(180deg);
      }
    }
  }
  .consign_rel_cont ul li.cur {
    border: 1px solid #ff5e5e;
  }
  .consign_rel_cont ul li.cur .is_choose {
    visibility: visible;
  }
}
.sprite_odr {
  background-image: url("../../assets/images/odr_cfm_spt.png");
  background-repeat: no-repeat;
}
.change {
  height: 120px;
}
.changes {
  height: auto !important;
}
.bill-list {
  height: 30px;
  line-height: 30px;
}
.assets_rel_cont {
  /*     padding: 10px 0px; */
  color: #c00;
  background-color: #ffc;
  width: 98%;
  clear: both;
  margin: 10px auto;
  /*     padding: 6px;
border: 1px dashed #f90;  */
  .assets_items {
    padding: 3px 0;
    margin: 1px 0;
    .assets_itms_info {
      height: 28px;
      line-height: 28px;
      .aii_labe {
        float: left;
        width: 157px;
        .inv_tips_txt {
          position: relative;
          float: left;
          width: 12px;
          height: 12px;
          padding-bottom: 5px;
          margin-top: 2px;
          margin-left: 6px;
          .inv_icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            background-position: -28px -35px;
          }
          .odr_tips {
            visibility: hidden;
            position: absolute;
            left: -34px;
            top: 21px;
            z-index: 33;
            display: block;
            width: 220px;
            padding: 2px 6px;
            line-height: 20px;
            background-color: #fff7d1;
            border: 1px solid #e5debc;
            color: #666;
            -moz-border-radius: 2px;
            -webkit-border-radius: 2px;
            border-radius: 2px;
          }
        }
      }
      .aii_tiptxt {
        float: left;
        color: #666;
      }
      .aii_chkbox {
        float: left;
        margin-left: 20px;
        cursor: pointer;
        input {
          position: relative;
          top: 2px;
          color: #666;
          cursor: pointer;
        }
      }
      .sp_totals {
        color: #666;
        margin-right: 10px;
      }
    }
  }
}
</style>
<style lang="less" type="text/less">
.checkout {
  .ivu-radio .ivu-radio-inner {
    height: 12px;
    width: 12px;
  }
  .ivu-select-single .ivu-select-selection {
    height: 24px;
  }
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    padding-left: 4px;
    padding-right: 20px;
    height: 24px;
    line-height: 24px;
    text-align: center;
  }
  .ivu-select-item {
    overflow-x: auto;
    text-align: center;
  }
  .remark {
    .ivu-input {
      padding: 0px;
      height: 24px !important;
    }
  }
  .info {
    margin-left: 6px;
    width: 200px;
    input {
      padding: 0px;
      height: 24px;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// checkout.vue?dcbe9f04